import styles from '~/styles/atoms/footer/footer.module.scss'

import { copyRightText } from '~/common/utils/copyright'
import { addClass } from '~/common/utils/html'

const CopyRightFooter = () => {
  return (
    <footer className={styles.footer + addClass(styles.copyright)}>
      {copyRightText}
    </footer>
  )
}

export default CopyRightFooter